// extracted by mini-css-extract-plugin
export var pillWrapper = "_l4-0";
export var showOverflow = "_l4-1";